import { Col as AntCol } from 'antd';
import styled from 'styled-components';

import { ColorEnum } from '@enum/style/color.enum';

export const ColStats = styled(AntCol)`
  display: flex;
  flex-direction: column;
  justify-content: start;
  border-right: 1px solid ${ColorEnum.Black10};
  padding: 0 16px 0 24px !important;

  &:first-child {
    padding-left: 8px !important;
  }

  &:last-child {
    border-right: none;
    padding-right: 0 !important;
  }
`;
